import { Helmet } from 'react-helmet-async';
import { JsonLd } from './JsonLdSchema';

const SITE_URL = 'https://www.restainpace.it';
const SITE_NAME = 'Resta in Pace';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

const PageSEO = ({ title, description, path, type = 'website', image, noindex = false, keywords, schema }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Necrologi, Commemorazioni e Servizi Funebri in Italia`;
  const url = path ? `${SITE_URL}${path}` : SITE_URL;
  const img = image || DEFAULT_IMAGE;

  return (
    <>
      <Helmet title={String(fullTitle)}>
        <meta name="description" content={description || ''} />
        {keywords && <meta name="keywords" content={keywords} />}
        <link rel="canonical" href={url} />
        {noindex && <meta name="robots" content="noindex,nofollow" />}

        {/* Open Graph */}
        <meta property="og:type" content={type} />
        <meta property="og:title" content={fullTitle} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={img} />
        <meta property="og:site_name" content={SITE_NAME} />
        <meta property="og:locale" content="it_IT" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={fullTitle} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={img} />
      </Helmet>

      {/* Structured data (JSON-LD) — iniettato via createElement per evitare bug Helmet children */}
      {schema && (
        <JsonLd id="page-seo-schema" data={typeof schema === 'string' ? JSON.parse(schema) : schema} />
      )}
    </>
  );
};

export default PageSEO;
